import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-breadcrumbs-example',
  templateUrl: './breadcrumbs.component.html',
})
export class KitBootstrapBreadcrumbsExampleComponent {}
